import './modals.css';

export const CancelSubscriptionModal = ({ onConfirm, onCancel, isLoading }) => (
  <div className="password-change-modal-overlay" onClick={onCancel}>
    <div className="password-change-modal" onClick={(e) => e.stopPropagation()}>
      <div className="password-change-modal-icon">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="22" stroke="#ef4444" strokeWidth="2" fill="rgba(239, 68, 68, 0.1)" />
          <path d="M24 16v12M24 32h.01" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <h2 className="password-change-modal-title">Cancel subscription?</h2>
      <p className="password-change-modal-message">
        You'll lose access to premium features at the end of your current billing period. You can resubscribe anytime.
      </p>
      <div className="password-change-modal-actions">
        <button className="password-change-modal-button-secondary" onClick={onCancel} disabled={isLoading}>
          Keep subscription
        </button>
        <button
          className="password-change-modal-button cancel-subscription-confirm-button"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? 'Canceling...' : 'Yes, cancel'}
        </button>
      </div>
    </div>
  </div>
);
